import { parseSync } from '@babel/core';
export var APPEND_CHILDREN = parse("function __damu__appendChildren(\n  parent,\n  children\n) {\n  children = Array.isArray(children) ? children : [children];\n  children.forEach(function(child) {\n    parent.appendChild(child);\n  });\n}");
export var APPEND_CHILD_WITH_COMPONENT = parse("function __damu__appendChildren(parent, children) {\n    children = Array.isArray(children) ? children : [children];\n    children.forEach(function(child) {\n      if (typeof child.render === 'function') {\n        child = child.render();\n      }\n      parent.appendChild(child);\n    });\n  }");

function parse() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return parseSync(fns.join('')).program.body[0];
}